module.exports = __webpack_public_path__ + "media/images/empty-search-90cbfdaa64ddc8603a8b3573f010cbf9.png";